var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_bookmark_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 169.92,
    y1: 180.66,
    x2: 259.2,
    y2: 180.66,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_bookmark_svg__linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 175.92,
    y1: 180.66,
    x2: 253.2,
    y2: 180.66,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "add_bookmark_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 24.566406 28.253906 C 24.375 28.253906 24.1875 28.191406 24.035156 28.074219 L 15.96875 22.074219 L 7.898438 28.074219 C 7.746094 28.191406 7.5625 28.253906 7.367188 28.253906 C 7.230469 28.253906 7.089844 28.21875 6.96875 28.15625 C 6.664062 28.003906 6.472656 27.699219 6.472656 27.359375 L 6.472656 4.613281 C 6.472656 4.121094 6.875 3.722656 7.367188 3.722656 L 24.566406 3.722656 C 25.058594 3.722656 25.460938 4.121094 25.460938 4.613281 L 25.460938 27.359375 C 25.460938 27.699219 25.273438 28.003906 24.96875 28.15625 C 24.84375 28.21875 24.707031 28.253906 24.566406 28.253906 Z M 15.96875 20.066406 C 16.160156 20.066406 16.34375 20.128906 16.5 20.242188 L 23.675781 25.582031 L 23.675781 5.507812 L 8.261719 5.507812 L 8.261719 25.582031 L 15.433594 20.242188 C 15.589844 20.128906 15.773438 20.066406 15.96875 20.066406 Z M 15.96875 20.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 24.566406 27.804688 C 24.472656 27.804688 24.378906 27.777344 24.300781 27.71875 L 15.96875 21.515625 L 7.632812 27.71875 C 7.5 27.816406 7.316406 27.835938 7.167969 27.757812 C 7.015625 27.683594 6.921875 27.527344 6.921875 27.359375 L 6.921875 4.613281 C 6.921875 4.367188 7.121094 4.167969 7.367188 4.167969 L 24.566406 4.167969 C 24.8125 4.167969 25.011719 4.367188 25.011719 4.613281 L 25.011719 27.359375 C 25.011719 27.527344 24.917969 27.683594 24.765625 27.757812 C 24.703125 27.789062 24.636719 27.804688 24.566406 27.804688 Z M 15.96875 20.511719 C 16.0625 20.511719 16.15625 20.542969 16.234375 20.601562 L 24.121094 26.46875 L 24.121094 5.058594 L 7.8125 5.058594 L 7.8125 26.46875 L 15.699219 20.601562 C 15.78125 20.542969 15.875 20.511719 15.96875 20.511719 Z M 15.96875 20.511719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#add_bookmark_svg__linear0)"
    },
    d: "M 15.96875 16.765625 C 15.472656 16.765625 15.074219 16.367188 15.074219 15.875 L 15.074219 14.335938 L 13.539062 14.335938 C 13.046875 14.335938 12.644531 13.9375 12.644531 13.445312 C 12.644531 12.953125 13.046875 12.550781 13.539062 12.550781 L 15.074219 12.550781 L 15.074219 11.015625 C 15.074219 10.523438 15.472656 10.121094 15.96875 10.121094 C 16.460938 10.121094 16.859375 10.523438 16.859375 11.015625 L 16.859375 12.550781 L 18.394531 12.550781 C 18.890625 12.550781 19.289062 12.953125 19.289062 13.445312 C 19.289062 13.9375 18.890625 14.335938 18.394531 14.335938 L 16.859375 14.335938 L 16.859375 15.875 C 16.859375 16.367188 16.460938 16.765625 15.96875 16.765625 Z M 15.96875 16.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#add_bookmark_svg__linear1)"
    },
    d: "M 15.96875 16.320312 C 15.722656 16.320312 15.519531 16.121094 15.519531 15.875 L 15.519531 13.890625 L 13.539062 13.890625 C 13.292969 13.890625 13.089844 13.691406 13.089844 13.445312 C 13.089844 13.199219 13.292969 12.996094 13.539062 12.996094 L 15.519531 12.996094 L 15.519531 11.015625 C 15.519531 10.769531 15.722656 10.570312 15.96875 10.570312 C 16.214844 10.570312 16.414062 10.769531 16.414062 11.015625 L 16.414062 12.996094 L 18.394531 12.996094 C 18.644531 12.996094 18.84375 13.199219 18.84375 13.445312 C 18.84375 13.691406 18.644531 13.890625 18.394531 13.890625 L 16.414062 13.890625 L 16.414062 15.875 C 16.414062 16.121094 16.214844 16.320312 15.96875 16.320312 Z M 15.96875 16.320312 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBookmark);
export default __webpack_public_path__ + "static/media/add_bookmark.dea92d636d3780de6c612c57d794ef5d.svg";
export { ForwardRef as ReactComponent };